export const langIso = {
	ab: {
		name: "Abkhaz",
		original: "аҧсуа",
		iso3: "abk",
	},
	aa: {
		name: "Afar",
		original: "Afaraf",
		iso3: "aar",
	},
	af: {
		name: "Afrikaans",
		original: "Afrikaans",
		iso3: "afr",
	},
	ak: {
		name: "Akan",
		original: "Akan",
		iso3: "aka",
	},
	sq: {
		name: "Albanian",
		original: "Shqip",
		iso3: "alb",
	},
	am: {
		name: "Amharic",
		original: "አማርኛ",
		iso3: "amh",
	},
	ar: {
		name: "Arabic",
		original: "العربية",
		iso3: "ara",
	},
	an: {
		name: "Aragonese",
		original: "Aragonés",
		iso3: "arg",
	},
	hy: {
		name: "Armenian",
		original: "Հայերեն",
		iso3: "arm",
	},
	as: {
		name: "Assamese",
		original: "অসমীয়া",
		iso3: "asm",
	},
	av: {
		name: "Avaric",
		original: "авар мацӀ, магӀарул мацӀ",
		iso3: "ava",
	},
	ae: {
		name: "Avestan",
		original: "avesta",
		iso3: "ave",
	},
	ay: {
		name: "Aymara",
		original: "aymar aru",
		iso3: "aym",
	},
	az: {
		name: "Azerbaijani",
		original: "azərbaycan dili",
		iso3: "aze",
	},
	bm: {
		name: "Bambara",
		original: "bamanankan",
		iso3: "bam",
	},
	ba: {
		name: "Bashkir",
		original: "башҡорт теле",
		iso3: "bak",
	},
	eu: {
		name: "Basque",
		original: "euskara, euskera",
		iso3: "baq",
	},
	be: {
		name: "Belarusian",
		original: "Беларуская",
		iso3: "bel",
	},
	bn: {
		name: "Bengali",
		original: "বাংলা",
		iso3: "ben",
	},
	bh: {
		name: "Bihari",
		original: "भोजपुरी",
		iso3: "bih",
	},
	bi: {
		name: "Bislama",
		original: "Bislama",
		iso3: "bis",
	},
	bs: {
		name: "Bosnian",
		original: "bosanski jezik",
		iso3: "bos",
	},
	br: {
		name: "Breton",
		original: "brezhoneg",
		iso3: "bre",
	},
	bg: {
		name: "Bulgarian",
		original: "български език",
		iso3: "bul",
	},
	my: {
		name: "Burmese",
		original: "ဗမာစာ",
		iso3: "bur",
	},
	ca: {
		name: "Catalan; Valencian",
		original: "Català",
		iso3: "cat",
	},
	ch: {
		name: "Chamorro",
		original: "Chamoru",
		iso3: "cha",
	},
	ce: {
		name: "Chechen",
		original: "нохчийн мотт",
		iso3: "che",
	},
	ny: {
		name: "Chichewa; Chewa; Nyanja",
		original: "chiCheŵa, chinyanja",
		iso3: "nya",
	},
	zh: {
		name: "Chinese",
		original: "中文 (Zhōngwén), 汉语, 漢語",
		iso3: "chi",
	},
	cv: {
		name: "Chuvash",
		original: "чӑваш чӗлхи",
		iso3: "chv",
	},
	kw: {
		name: "Cornish",
		original: "Kernewek",
		iso3: "cor",
	},
	co: {
		name: "Corsican",
		original: "corsu, lingua corsa",
		iso3: "cos",
	},
	cr: {
		name: "Cree",
		original: "ᓀᐦᐃᔭᐍᐏᐣ",
		iso3: "cre",
	},
	hr: {
		name: "Croatian",
		original: "hrvatski",
		iso3: "hrv",
	},
	cs: {
		name: "Czech",
		original: "česky, čeština",
		iso3: "cze",
	},
	da: {
		name: "Danish",
		original: "dansk",
		iso3: "dan",
	},
	dv: {
		name: "Divehi; Dhivehi; Maldivian;",
		original: "ދިވެހި",
		iso3: "div",
	},
	nl: {
		name: "Dutch",
		original: "Nederlands, Vlaams",
		iso3: "dut",
	},
	en: {
		name: "English",
		original: "English",
		iso3: "eng",
	},
	eo: {
		name: "Esperanto",
		original: "Esperanto",
		iso3: "epo",
	},
	et: {
		name: "Estonian",
		original: "eesti, eesti keel",
		iso3: "est",
	},
	ee: {
		name: "Ewe",
		original: "Eʋegbe",
		iso3: "ewe",
	},
	fo: {
		name: "Faroese",
		original: "føroyskt",
		iso3: "fao",
	},
	fj: {
		name: "Fijian",
		original: "vosa Vakaviti",
		iso3: "fij",
	},
	fi: {
		name: "Finnish",
		original: "suomi, suomen kieli",
		iso3: "fin",
	},
	fr: {
		name: "French",
		original: "français",
		iso3: "fre",
	},
	ff: {
		name: "Fula; Fulah; Pulaar; Pular",
		original: "Fulfulde, Pulaar, Pular",
		iso3: "ful",
	},
	gl: {
		name: "Galician",
		original: "Galego",
		iso3: "glg",
	},
	ka: {
		name: "Georgian",
		original: "ქართული",
		iso3: "geo",
	},
	de: {
		name: "German",
		original: "Deutsch",
		iso3: "ger",
	},
	el: {
		name: "Greek, Modern",
		original: "Ελληνικά",
		iso3: "gre",
	},
	gn: {
		name: "Guaraní",
		original: "Avañeẽ",
		iso3: "grn",
	},
	gu: {
		name: "Gujarati",
		original: "ગુજરાતી",
		iso3: "guj",
	},
	ht: {
		name: "Haitian; Haitian Creole",
		original: "Kreyòl ayisyen",
		iso3: "hat",
	},
	ha: {
		name: "Hausa",
		original: "Hausa, هَوُسَ",
		iso3: "hau",
	},
	he: {
		name: "Hebrew (modern)",
		original: "עברית",
		iso3: "heb",
	},
	hz: {
		name: "Herero",
		original: "Otjiherero",
		iso3: "her",
	},
	hi: {
		name: "Hindi",
		original: "हिन्दी, हिंदी",
		iso3: "hin",
	},
	ho: {
		name: "Hiri Motu",
		original: "Hiri Motu",
		iso3: "hmo",
	},
	hu: {
		name: "Hungarian",
		original: "Magyar",
		iso3: "hun",
	},
	ia: {
		name: "Interlingua",
		original: "Interlingua",
		iso3: "ina",
	},
	id: {
		name: "Indonesian",
		original: "Bahasa Indonesia",
		iso3: "ind",
	},
	ie: {
		name: "Interlingue",
		original: "Originally called Occidental; then Interlingue after WWII",
		iso3: "ile",
	},
	ga: {
		name: "Irish",
		original: "Gaeilge",
		iso3: "gle",
	},
	ig: {
		name: "Igbo",
		original: "Asụsụ Igbo",
		iso3: "ibo",
	},
	ik: {
		name: "Inupiaq",
		original: "Iñupiaq, Iñupiatun",
		iso3: "ipk",
	},
	io: {
		name: "Ido",
		original: "Ido",
		iso3: "ido",
	},
	is: {
		name: "Icelandic",
		original: "Íslenska",
		iso3: "ice",
	},
	it: {
		name: "Italian",
		original: "Italiano",
		iso3: "ita",
	},
	iu: {
		name: "Inuktitut",
		original: "ᐃᓄᒃᑎᑐᑦ",
		iso3: "iku",
	},
	ja: {
		name: "Japanese",
		original: "日本語 (にほんご／にっぽんご)",
		iso3: "jpn",
	},
	jv: {
		name: "Javanese",
		original: "basa Jawa",
		iso3: "jav",
	},
	kl: {
		name: "Kalaallisut, Greenlandic",
		original: "kalaallisut, kalaallit oqaasii",
		iso3: "kal",
	},
	kn: {
		name: "Kannada",
		original: "ಕನ್ನಡ",
		iso3: "kan",
	},
	kr: {
		name: "Kanuri",
		original: "Kanuri",
		iso3: "kau",
	},
	ks: {
		name: "Kashmiri",
		original: "कश्मीरी, كشميري‎",
		iso3: "kas",
	},
	kk: {
		name: "Kazakh",
		original: "Қазақ тілі",
		iso3: "kaz",
	},
	km: {
		name: "Khmer",
		original: "ភាសាខ្មែរ",
		iso3: "khm",
	},
	ki: {
		name: "Kikuyu, Gikuyu",
		original: "Gĩkũyũ",
		iso3: "kik",
	},
	rw: {
		name: "Kinyarwanda",
		original: "Ikinyarwanda",
		iso3: "kin",
	},
	ky: {
		name: "Kirghiz, Kyrgyz",
		original: "кыргыз тили",
		iso3: "kir",
	},
	kv: {
		name: "Komi",
		original: "коми кыв",
		iso3: "kom",
	},
	kg: {
		name: "Kongo",
		original: "KiKongo",
		iso3: "kon",
	},
	ko: {
		name: "Korean",
		original: "한국어 (韓國語), 조선말 (朝鮮語)",
		iso3: "kor",
	},
	ku: {
		name: "Kurdish",
		original: "Kurdî, كوردی‎",
		iso3: "kur",
	},
	kj: {
		name: "Kwanyama, Kuanyama",
		original: "Kuanyama",
		iso3: "kua",
	},
	la: {
		name: "Latin",
		original: "latine, lingua latina",
		iso3: "lat",
	},
	lb: {
		name: "Luxembourgish, Letzeburgesch",
		original: "Lëtzebuergesch",
		iso3: "ltz",
	},
	lg: {
		name: "Luganda",
		original: "Luganda",
		iso3: "lug",
	},
	li: {
		name: "Limburgish, Limburgan, Limburger",
		original: "Limburgs",
		iso3: "lim",
	},
	ln: {
		name: "Lingala",
		original: "Lingála",
		iso3: "lin",
	},
	lo: {
		name: "Lao",
		original: "ພາສາລາວ",
		iso3: "lao",
	},
	lt: {
		name: "Lithuanian",
		original: "lietuvių kalba",
		iso3: "lit",
	},
	lu: {
		name: "Luba-Katanga",
		iso3: "lub",
	},
	lv: {
		name: "Latvian",
		original: "latviešu valoda",
		iso3: "lav",
	},
	gv: {
		name: "Manx",
		original: "Gaelg, Gailck",
		iso3: "glv",
	},
	mk: {
		name: "Macedonian",
		original: "македонски јазик",
		iso3: "mac",
	},
	mg: {
		name: "Malagasy",
		original: "Malagasy fiteny",
		iso3: "mlg",
	},
	ms: {
		name: "Malay",
		original: "bahasa Melayu, بهاس ملايو‎",
		iso3: "may",
	},
	ml: {
		name: "Malayalam",
		original: "മലയാളം",
		iso3: "mal",
	},
	mt: {
		name: "Maltese",
		original: "Malti",
		iso3: "mlt",
	},
	mi: {
		name: "Māori",
		original: "te reo Māori",
		iso3: "mao",
	},
	mr: {
		name: "Marathi (Marāṭhī)",
		original: "मराठी",
		iso3: "mar",
	},
	mh: {
		name: "Marshallese",
		original: "Kajin M̧ajeļ",
		iso3: "mah",
	},
	mn: {
		name: "Mongolian",
		original: "монгол",
		iso3: "mon",
	},
	na: {
		name: "Nauru",
		original: "Ekakairũ Naoero",
		iso3: "nau",
	},
	nv: {
		name: "Navajo, Navaho",
		original: "Diné bizaad, Dinékʼehǰí",
		iso3: "nav",
	},
	nb: {
		name: "Norwegian Bokmål",
		original: "Norsk bokmål",
		iso3: "nob",
	},
	nd: {
		name: "North Ndebele",
		original: "isiNdebele",
		iso3: "nde",
	},
	ne: {
		name: "Nepali",
		original: "नेपाली",
		iso3: "nep",
	},
	ng: {
		name: "Ndonga",
		original: "Owambo",
		iso3: "ndo",
	},
	nn: {
		name: "Norwegian Nynorsk",
		original: "Norsk nynorsk",
		iso3: "nno",
	},
	no: {
		name: "Norwegian",
		original: "Norsk",
		iso3: "nor",
	},
	ii: {
		name: "Nuosu",
		original: "ꆈꌠ꒿ Nuosuhxop",
		iso3: "iii",
	},
	nr: {
		name: "South Ndebele",
		original: "isiNdebele",
		iso3: "nbl",
	},
	oc: {
		name: "Occitan",
		original: "Occitan",
		iso3: "oci",
	},
	oj: {
		name: "Ojibwe, Ojibwa",
		original: "ᐊᓂᔑᓈᐯᒧᐎᓐ",
		iso3: "oji",
	},
	cu: {
		name: "Old Church Slavonic",
		original: "ѩзыкъ словѣньскъ",
		iso3: "chu",
	},
	om: {
		name: "Oromo",
		original: "Afaan Oromoo",
		iso3: "orm",
	},
	or: {
		name: "Oriya",
		original: "ଓଡ଼ିଆ",
		iso3: "ori",
	},
	os: {
		name: "Ossetian, Ossetic",
		original: "ирон æвзаг",
		iso3: "oss",
	},
	pa: {
		name: "Panjabi, Punjabi",
		original: "ਪੰਜਾਬੀ, پنجابی‎",
		iso3: "pan",
	},
	pi: {
		name: "Pāli",
		original: "पाऴि",
		iso3: "pli",
	},
	fa: {
		name: "Persian",
		original: "فارسی",
		iso3: "per",
	},
	pl: {
		name: "Polish",
		original: "polski",
		iso3: "pol",
	},
	ps: {
		name: "Pashto, Pushto",
		original: "پښتو",
		iso3: "pus",
	},
	pt: {
		name: "Portuguese",
		original: "Português",
		iso3: "por",
	},
	qu: {
		name: "Quechua",
		original: "Runa Simi, Kichwa",
		iso3: "que",
	},
	rm: {
		name: "Romansh",
		original: "rumantsch grischun",
		iso3: "roh",
	},
	rn: {
		name: "Kirundi",
		original: "kiRundi",
		iso3: "run",
	},
	ro: {
		name: "Romanian, Moldavian, Moldovan",
		original: "română",
		iso3: "rum",
	},
	ru: {
		name: "Russian",
		original: "русский язык",
		iso3: "rus",
	},
	sa: {
		name: "Sanskrit (Saṁskṛta)",
		original: "संस्कृतम्",
		iso3: "san",
	},
	sc: {
		name: "Sardinian",
		original: "sardu",
		iso3: "srd",
	},
	sd: {
		name: "Sindhi",
		original: "सिन्धी, سنڌي، سندھی‎",
		iso3: "snd",
	},
	se: {
		name: "Northern Sami",
		original: "Davvisámegiella",
		iso3: "sme",
	},
	sm: {
		name: "Samoan",
		original: "gagana faa Samoa",
		iso3: "smo",
	},
	sg: {
		name: "Sango",
		original: "yângâ tî sängö",
		iso3: "sag",
	},
	sr: {
		name: "Serbian",
		original: "српски језик",
		iso3: "srp",
	},
	gd: {
		name: "Scottish Gaelic; Gaelic",
		original: "Gàidhlig",
		iso3: "gla",
	},
	sn: {
		name: "Shona",
		original: "chiShona",
		iso3: "sna",
	},
	si: {
		name: "Sinhala, Sinhalese",
		original: "සිංහල",
		iso3: "sin",
	},
	sk: {
		name: "Slovak",
		original: "slovenčina",
		iso3: "slo",
	},
	sl: {
		name: "Slovene",
		original: "slovenščina",
		iso3: "slv",
	},
	so: {
		name: "Somali",
		original: "Soomaaliga, af Soomaali",
		iso3: "som",
	},
	st: {
		name: "Southern Sotho",
		original: "Sesotho",
		iso3: "sot",
	},
	es: {
		name: "Spanish; Castilian",
		original: "español, castellano",
		iso3: "spa",
	},
	su: {
		name: "Sundanese",
		original: "Basa Sunda",
		iso3: "sun",
	},
	sw: {
		name: "Swahili",
		original: "Kiswahili",
		iso3: "swa",
	},
	ss: {
		name: "Swati",
		original: "SiSwati",
		iso3: "ssw",
	},
	sv: {
		name: "Swedish",
		original: "svenska",
		iso3: "swe",
	},
	ta: {
		name: "Tamil",
		original: "தமிழ்",
		iso3: "tam",
	},
	te: {
		name: "Telugu",
		original: "తెలుగు",
		iso3: "tel",
	},
	tg: {
		name: "Tajik",
		original: "тоҷикӣ, toğikī, تاجیکی‎",
		iso3: "tgk",
	},
	th: {
		name: "Thai",
		original: "ไทย",
		iso3: "tha",
	},
	ti: {
		name: "Tigrinya",
		original: "ትግርኛ",
		iso3: "tir",
	},
	bo: {
		name: "Tibetan Standard, Tibetan, Central",
		original: "བོད་ཡིག",
		iso3: "tib",
	},
	tk: {
		name: "Turkmen",
		original: "Türkmen, Түркмен",
		iso3: "tuk",
	},
	tl: {
		name: "Tagalog",
		original: "Wikang Tagalog, ᜏᜒᜃᜅ᜔ ᜆᜄᜎᜓᜄ᜔",
		iso3: "tgl",
	},
	tn: {
		name: "Tswana",
		original: "Setswana",
		iso3: "tsn",
	},
	to: {
		name: "Tonga (Tonga Islands)",
		original: "faka Tonga",
		iso3: "ton",
	},
	tr: {
		name: "Turkish",
		original: "Türkçe",
		iso3: "tur",
	},
	ts: {
		name: "Tsonga",
		original: "Xitsonga",
		iso3: "tso",
	},
	tt: {
		name: "Tatar",
		original: "татарча, tatarça, تاتارچا‎",
		iso3: "tat",
	},
	tw: {
		name: "Twi",
		original: "Twi",
		iso3: "twi",
	},
	ty: {
		name: "Tahitian",
		original: "Reo Tahiti",
		iso3: "tah",
	},
	ug: {
		name: "Uighur, Uyghur",
		original: "Uyƣurqə, ئۇيغۇرچە‎",
		iso3: "uig",
	},
	uk: {
		name: "Ukrainian",
		original: "українська",
		iso3: "ukr",
	},
	ur: {
		name: "Urdu",
		original: "اردو",
		iso3: "urd",
	},
	uz: {
		name: "Uzbek",
		original: "zbek, Ўзбек, أۇزبېك‎",
		iso3: "uzb",
	},
	ve: {
		name: "Venda",
		original: "Tshivenḓa",
		iso3: "ven",
	},
	vi: {
		name: "Vietnamese",
		original: "Tiếng Việt",
		iso3: "vie",
	},
	vo: {
		name: "Volapük",
		original: "Volapük",
		iso3: "vol",
	},
	wa: {
		name: "Walloon",
		original: "Walon",
		iso3: "wln",
	},
	cy: {
		name: "Welsh",
		original: "Cymraeg",
		iso3: "wel",
	},
	wo: {
		name: "Wolof",
		original: "Wollof",
		iso3: "wol",
	},
	fy: {
		name: "Western Frisian",
		original: "Frysk",
		iso3: "fry",
	},
	xh: {
		name: "Xhosa",
		original: "isiXhosa",
		iso3: "xho",
	},
	yi: {
		name: "Yiddish",
		original: "ייִדיש",
		iso3: "yid",
	},
	yo: {
		name: "Yoruba",
		original: "Yorùbá",
		iso3: "yor",
	},
	za: {
		name: "Zhuang, Chuang",
		original: "Saɯ cueŋƅ, Saw cuengh",
		iso3: "zha",
	},
} as const;
